import { getUserToken } from "../../../common/userfuctions";
import { PostWithData } from "../https";

const SERVER_URL = process.env.REACT_APP_HIRE_SIDE_API;


export const GetCountriesCity = (CountryCode) => {
    const UserToken = getUserToken();
  
    let params = {
      r: "Jobs",
      rt: "GetCountriesCity",
      member: 1,
      p: JSON.stringify({
        AccessToken: UserToken,
        CountryCode: CountryCode
      }),
    };
  
    return PostWithData(SERVER_URL, params, {});
  };